import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=6486f880&scoped=true"
import script from "./LinkExpired.vue?vue&type=script&lang=js"
export * from "./LinkExpired.vue?vue&type=script&lang=js"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=6486f880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486f880",
  null
  
)

export default component.exports